<div class="field-container">
  <input class="field-container__input" type="text" required (input)="getChangeVal($event.target.value)" (keyup.enter)="valFromEnter($event.target.value)">
  <label class="field-container__label">{{placeholderVal}}</label>
</div>
